module.exports = __webpack_public_path__ + "static/media/attach-form.72fb7a99.svg";